import { render, staticRenderFns } from "./BlocoModalidade.vue?vue&type=template&id=611bbb83&scoped=true"
import script from "./BlocoModalidade.vue?vue&type=script&lang=js"
export * from "./BlocoModalidade.vue?vue&type=script&lang=js"
import style0 from "./BlocoModalidade.vue?vue&type=style&index=0&id=611bbb83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611bbb83",
  null
  
)

export default component.exports